import { RDLivestock } from '@cibo/core'
import { useFigures } from '@cibo/ui'
import { useTranslation } from 'react-i18next'
import { DetailPanelTable } from '../DetailPanelTable'

import { useMemo } from 'react'

export const LivestockPanelTable = () => {
  const { t } = useTranslation('@cibo/landmanager/LivestockPanelTable')
  const { livestockSpecies } = useFigures()
  const columns = useMemo(
    () => [
      {
        header: t('species'),
        cellContents: (livestock?: RDLivestock) => (
          <>
            {livestock?.input?.species !== undefined
              ? livestockSpecies(livestock.input.species)
              : '--'}
          </>
        ),
      },
      {
        header: t('head'),
        cellContents: (livestock?: RDLivestock) => (
          <>{!!livestock?.input?.headcount ? livestock.input?.headcount : '--'}</>
        ),
      },
      {
        header: t('daysGrazing'),
        cellContents: (livestock?: RDLivestock) => (
          <>{!!livestock?.input?.daysGrazing ? livestock?.input?.daysGrazing : '--'}</>
        ),
      },
    ],
    []
  )
  return <DetailPanelTable<RDLivestock> traitId="livestock" columns={columns} />
}
